<template>
  <p v-html="bookName"></p>
</template>

<script>
export default {
  name: 'dealBookName',
  props: {
    nameVal: {
      type: String
    }
  },
  mounted () {
  },
  computed: {
    bookName () {
      if (this.nameVal) {
        return this.nameVal.replace(' ', '<br>')
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
